import type { AllRouteEndpoints } from "../routeTypes";

export const conversationalToolDefinitionId = "/:app_group_id/conversational/tool_definition/:id";

export const conversationalToolDefinitionIdCacheKeys: AllRouteEndpoints[] = [
  "/:app_group_id/conversational/tool_definition/:id",
  "/:app_group_id/conversational/tool_definitions",
];
